module.exports = __webpack_public_path__ + "static/media/ad-manat.36205184.svg";